import React from 'react';
import { useField } from 'formik';
import { TextField, TextFieldProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface FormikInputProps {
  name: string;
}

export default function FormikInput(props: FormikInputProps & TextFieldProps) {
  const [field, meta] = useField({ name: props.name });
  const { t } = useTranslation();
  const hasError = meta.touched && !!meta.error;

  return (
    <TextField
      error={hasError}
      helperText={hasError ? t(meta.error || '') : ''}
      InputProps={props.InputProps}
      id={field.name}
      {...field}
      {...props}
    />
  );
}
